var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"conectividad full-width full-height"},[_c('Intro'),_c('Acceso'),_c('Transporte'),_c('Red'),_c('Lambdas')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }